import { takeLatest, call, put } from 'redux-saga/effects';
import memberAdminNoSessionApi from 'api/employee/memberAdminNoSessionApi';
import * as findPasswordActions from 'redux/ducks/findPassword/findPasswordDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';
import i18n from 'i18n';

export function* getAuthenticateFnm({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getAuthenticateFnm, payload);
    if (['V', 'R'].indexOf(response.emInofcStatsCd) !== -1) {
      yield put(alertActions.open({ message: ['MB_M_FINDPWD_FNM_ID_NOT_EM_STATUS'] }));
    } else {
      yield put(findPasswordActions.getAuthenticateFnmSuccess(response));
    }
  } catch (error) {
    yield put(findPasswordActions.setAuthenticateFnmFail(error));
  }
}

export function* getAuthenticateCallPhone({ payload }) {
  try {
    yield put(findPasswordActions.setRequestOtpState(false));
    const response = yield call(memberAdminNoSessionApi.getAuthenticateCallPhone, payload);
    yield put(findPasswordActions.getAuthenticateCallPhoneSuccess(response));
  } catch (error) {
    yield put(findPasswordActions.getAuthenticateCallPhoneFail([error.errorCode]));
    yield put(findPasswordActions.setRequestOtpState(true));
  }
}

export function* getAuthenticateExternalMail({ payload }) {
  try {
    yield put(findPasswordActions.setRequestOtpState(false));
    const response = yield call(memberAdminNoSessionApi.getAuthenticateExternalMail, payload);
    yield put(findPasswordActions.getAuthenticateExternalMailSuccess(response));
  } catch (error) {
    yield put(findPasswordActions.getAuthenticateExternalMailFail([error.errorCode]));
    yield put(findPasswordActions.setRequestOtpState(true));
  }
}

export function* getAuthenticateAuthNum({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getAuthenticateAuthNum, payload);
    yield put(findPasswordActions.getAuthenticateAuthNumSuccess(response));
    yield put(findPasswordActions.resetIncorrectOTPcount());
  } catch (error) {
    yield put(findPasswordActions.setAuthenticateAuthNumFail(error.errorCode));
  }
}

export function* modifyAuthenticatePassword({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.modifyAuthenticatePassword, payload);
    yield put(findPasswordActions.modifyAuthenticatePasswordSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getCheckPinCode({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getCheckPinCode, payload);
    if (response.pinValid) yield put(findPasswordActions.getCheckPinCodeSuccess(response));
    else {
      const errorMessage =
        response.certFailNum === 5
          ? 'EM0028'
          : { key: i18n.t('MB_T_KMS_PIN_INPUT_COUNT', { digit: response.certFailNum }) };
      yield put(alertActions.open({ message: [errorMessage] }));
      yield put(findPasswordActions.getCheckPinCodeFail(response));
    }
  } catch (error) {
    yield put(findPasswordActions.getCheckPinCodeFail(error.errorCode));
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getPinSendEmail({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getPinSendEmail, payload);
    yield put(findPasswordActions.getPinSendEmailSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getCheckMobileUser({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getCheckMobileUser, payload);
    yield put(findPasswordActions.getCheckMobileUserSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getMobileToken({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getMobileToken, payload);
    yield put(findPasswordActions.getMobileTokenSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* addMobilePush({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.addMobilePush, payload);
    yield put(findPasswordActions.addMobilePushSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* addSkip({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.addSkip, payload);
    yield put(findPasswordActions.addSkipSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}
export default function* findPasswordSaga() {
  yield takeLatest(findPasswordActions.getAuthenticateFnm, getAuthenticateFnm);
  yield takeLatest(findPasswordActions.getAuthenticateCallPhone, getAuthenticateCallPhone);
  yield takeLatest(findPasswordActions.getAuthenticateExternalMail, getAuthenticateExternalMail);
  yield takeLatest(findPasswordActions.getAuthenticateAuthNum, getAuthenticateAuthNum);
  yield takeLatest(findPasswordActions.modifyAuthenticatePassword, modifyAuthenticatePassword);
  yield takeLatest(findPasswordActions.getCheckPinCode, getCheckPinCode);
  yield takeLatest(findPasswordActions.getPinSendEmail, getPinSendEmail);
  yield takeLatest(findPasswordActions.getMobileToken, getMobileToken);
  yield takeLatest(findPasswordActions.getCheckMobileUser, getCheckMobileUser);
  yield takeLatest(findPasswordActions.addMobilePush, addMobilePush);
  yield takeLatest(findPasswordActions.addSkip, addSkip);
}
